<template>
    <el-dialog :visible.sync="visible" class="w-el-dialog" append-to-body title="修改项目类型" :close-on-click-modal="false" :close-on-press-escape="false">

        <el-form :model="form" label-width="120px" size="mini">

            
            <el-form-item label="项目类型名称"  :rules="[{ required: true, message: '必填项' }]" :error="formError.name?.toString()" prop="name">
                <el-input v-model="form.name" clearable placeholder="请填写项目类型名称"></el-input>
            </el-form-item>

            <el-form-item label="状态">
                <el-radio-group v-model="form.state">
                    <el-radio :label="0">不启用</el-radio>
                    <el-radio :label="1">启用</el-radio>
                </el-radio-group>
            </el-form-item>

        </el-form>

        <div slot="footer">
            <el-button size="small" @click="visible = false">取 消</el-button>
            <el-button size="small" type="primary" @click="FormSubmit()" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    data () {
        return {
            visible: false,
            loading: false,

            formError: {},
            form: {
                id: null,
                name: null,
                state: 1
            }

        }
    },

    methods: {
        Open(id) {
            this.visible = true
            this.loading = true

            this.$http.post('/9api/projects-type/search-first', { search: { id: id } }).then((rps) => {
                this.form.id = rps.data.id
                this.form.name = rps.data.name
                this.form.state = rps.data.state
                this.loading = false
            })
        },
        FormSubmit() {

            this.loading = true

            this.$http.post('/9api/projects-type/update', this.form).then((rps) => {

                                if (rps.data.state == 'error') {
                    this.formError = rps.data.body
                }

                                if (rps.data.state == 'success') {
                    this.$emit('onChange', rps.data.body)
                    this.visible = false
                }

                this.loading = false
            })
        },
    }
}
</script>